<template>
    <div class="col-8 col-md-10">
        <div v-if="typeFilters && typeFilters.length > 1" class="global-dealer-search__types">
            <div v-for="filter in typeFilters" :key="filter.name" class="global-dealer-search__type">
                <input :id="filter.name" class="form__input--checkbox checkbox-style--1" type="checkbox"
                       :checked="filter.selected" @change="selectTypeFilter(filter.name, $event.target.checked)">
                <label :for="filter.name" class="form__label">{{ filter.label }}</label>
            </div>
        </div>
    </div>
</template>


<script>

import GlobalTab from "@global/global-elements/global-tabs/global-tab.vue";
import DealerKeywordSearch from "@global/global-elements/global-dealer-search/components/dealer-keyword-search.vue";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";
import GlobalDropdown from "@global/global-elements/global-dropdown/global-dropdown.vue";
import GlobalTabs from "@global/global-elements/global-tabs/global-tabs.vue";
import {getUserCountry} from "@global/utilities/global-country-data.js";

export default {
    components: {GlobalTabs, GlobalDropdown, GlobalButton, DealerKeywordSearch, GlobalTab},
    computed: {
        typeFilters() {
            return this.$store.getters.getAvailableFilters
        }
    },
    methods: {
        selectTypeFilter(filterName, value) {
            this.$store.dispatch("setTypeFilter", {filterName: filterName, selected: value})
        },
    },
    mounted() {
        if (this.$store.getters.getCountry === null) {
            this.$store.dispatch('setCountry', getUserCountry())
        }

        if (this.$store.getters.getAvailableFilters.length === 0) {
            this.$store.dispatch('calculateAvailableFilters')
        }

        this.$store.dispatch('setDealerResults', null)
    }
}
</script>
